// assets/cart.pricing.js
window.CartMethodsPricing = {
    getTotalCalendarQty(curentId) {
        let result = 0;

        this.cartItems.forEach(
            el => {
                if (
                    el &&
                    el.id != curentId &&
                    el.product_title != "Associated Fee" &&
                    this.isCalendarProduct(el.properties)
                ) {
                    result += el.quantity;
                }
            }
            );

        return result;
    },

    isCurrentDateActive(startDate, endDate) {
        console.error("Start isCurrentDateActive isCurrentDateActive");
        console.warn(startDate);
        console.warn(endDate);

        let currentDate = new Date();
        startDate = new Date(startDate);
        endDate = new Date(endDate);

        console.error("End isCurrentDateActive isCurrentDateActive");
        console.warn(startDate);
        console.warn(endDate);

        return currentDate >= startDate && currentDate <= endDate;
    },

    isValidatedSpecialPrice(tierLine) {
        let isActiveDate = false;

        if(
            Object.prototype.hasOwnProperty.call(tierLine, 'sale_price_effectivedate') &&
            Object.prototype.hasOwnProperty.call(tierLine, 'sale_price_terminationdate') &&
            Object.prototype.hasOwnProperty.call(tierLine, 'sale_price')
        ) {
            isActiveDate = this.isCurrentDateActive(tierLine['sale_price_effectivedate'], tierLine['sale_price_terminationdate']);
        }

        return isActiveDate;
    },

    changePrice(cartItem,index) {
        // _price_details arrives as a JSON string after Shopify cart API refreshes cartItems
        // (Shopify always returns line-item properties as strings). Parse it so tier pricing
        // works regardless of property format. Also handles Design Online / items with no tiers.
        let priceDetails = cartItem.properties._price_details;
        if (typeof priceDetails === 'string') {
            try { priceDetails = JSON.parse(priceDetails); } catch(e) { priceDetails = null; }
        }
        if (!priceDetails || !priceDetails.tier || !priceDetails.tier.length) {
            console.warn('[changePrice] no _price_details for group', cartItem.properties._groupID, '— skipping tier recalc');
            return;
        }

        let groupID = this.cartItems[index].properties._groupID;
        let total = this.isCalendarProduct(cartItem.properties)
            ? (this.getTotalCalendarQty(this.cartItems[index].id) + this.cartItems[index].quantity)
            : (this.getTotalQtyByGroupId(this.cartItems[index].properties._groupID, this.cartItems[index].id) + this.cartItems[index].quantity);
        let priceByQty = 0;
        let minQtyPrice = this.isValidatedSpecialPrice(priceDetails.tier[0])
            ? priceDetails.tier[0].sale_price
            : priceDetails.tier[0].price;

        this.totalQtyByGroupID[groupID] = {};
        this.totalQtyByGroupID[groupID]['qty'] = total;

        priceDetails.tier.forEach(
            item => {
                if (item.QtyMin !== 'MSRP') {
                    if (total >= item.QtyMin) {
                        priceByQty = this.isValidatedSpecialPrice(item) ? item.sale_price : item.price;
                    }
                }
            }
        );

        let price = Number(priceByQty > 0 ? priceByQty : minQtyPrice);
        //let currentPrice = cartItem.price / 100;
        this.disableCheckout = true;
        let key = cartItem.properties._groupID;
        console.log("change : price for group " + cartItem.properties._groupID  );

        if(!this.priceChange.hasOwnProperty(key)) {
            this.priceChange[key] = {}
        }

        this.priceChange[key].price = price;
        this.priceChange[key]._groupId = cartItem.properties._groupID;
        localStorage.setItem('priceChange', JSON.stringify(this.priceChange));
    },

    /* SHO-411 Start Manualy qty change */
    roundChangedManualyQty(value,index,cartItem) {
        let qtyIncriment = Number(this.qtyIncriment[cartItem.properties._groupID]);

        // copied from vue, check if this this.minQty need in cart
        if(this.minQty < 0) {
            this.minQty = 0;
        }

        value = Number(value);

        this.cartItems[index].quantity = value;
        let currValue = qtyIncriment;

        if(value < qtyIncriment) {
            console.warn("if");
            currValue = qtyIncriment;

        } else if(value % qtyIncriment) {
            console.warn("else if");
            currValue = this.roundValueBy(value, qtyIncriment);
        }

        if(value > qtyIncriment && !(value % qtyIncriment)) {
            console.warn("if value > qtyIncriment && !(value % qtyIncriment)");
            currValue = value;
        }

        this.cartItems[index].quantity = currValue;

        return currValue;
    },

    roundValueBy(value, by) {
        return Math.round(parseInt(value) / parseInt(by)) * parseInt(by);
    },
    /* End Manualy qty change SHO-411 */

    showUpcharge(prID, itemProp) {

        if(
            this.properties[prID].hasOwnProperty("_sizeUpcharge")
            && this.properties[prID]._sizeUpcharge.hasOwnProperty(itemProp)
        ){
            let sign = this.properties[prID]._sizeUpcharge[itemProp] > 0 ? "+" : "-";
            return  `${sign} $${this.properties[prID]._sizeUpcharge[itemProp].toFixed(2)}`;
        }

        if(
            this.properties[prID].hasOwnProperty("_colorUpcharge")
            && this.properties[prID]._colorUpcharge.hasOwnProperty(itemProp)
        ){
            let sign = this.properties[prID]._colorUpcharge[itemProp].price > 0 ? "+" : "-";
            return `${sign} $${Math.abs(this.properties[prID]._colorUpcharge[itemProp].price).toFixed(2)}`;
        }
    },

    /**
     * Get current unit price for a cart item based on tier pricing.
     * NOTE: Additional price logic for specific product categories will be added here.
     * @param {Object} cartItem
     * @returns {Number} price in dollars
     */
    getUnitPrice(cartItem) {
        let priceDetails = cartItem.properties?._price_details;
        if (typeof priceDetails === 'string') {
            try { priceDetails = JSON.parse(priceDetails); } catch(e) { priceDetails = null; }
        }
        const tier = priceDetails?.tier;
        if (!tier || !tier.length) return cartItem.price / 100;

        const groupID = cartItem.properties._groupID;
        const total = this.isCalendarProduct(cartItem.properties)
            ? this.getTotalCalendarQty(cartItem.id) + cartItem.quantity
            : this.getTotalQtyByGroupId(groupID, cartItem.id) + cartItem.quantity;

        const minQtyPrice = this.isValidatedSpecialPrice(tier[0])
            ? tier[0].sale_price
            : tier[0].price;


        // B2B override: mirror changePrice()'s b2bTier logic so the
        // displayed "Unit Price:" always matches what's actually charged
        // (linePriceProperty / priceChange), including tier transitions.
        const b2bTiers = cartItem.properties._price_details?.b2bTier;
        if (b2bTiers && b2bTiers.length > 0) {
            let b2bPrice = null;
            b2bTiers.forEach(t => {
                if (total >= t.QtyMin) b2bPrice = t.price;
            });
            if (b2bPrice !== null) return Number(b2bPrice);

            // qty below all B2B tier minimums — same fallback as changePrice()
            const sortedB2b = [...b2bTiers].sort((a, b) => Number(a.QtyMin) - Number(b.QtyMin));
            return Number(sortedB2b[0].price);
        }

        let priceByQty = 0;
        tier.forEach(item => {
            if (item.QtyMin !== 'MSRP' && total >= item.QtyMin) {
                priceByQty = this.isValidatedSpecialPrice(item)
                    ? item.sale_price
                    : item.price;
            }
        });

        return Number(priceByQty > 0 ? priceByQty : minQtyPrice);
    },
};